var React = require('react');

function Heart (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M31 1C28.2385 1 25.7385 2.14247 23.9275 3.98828L20.9985 6.97655L18.0705 3.98828C16.2605 2.14247 13.7605 1 11 1C5.479 1 1 5.56581 1 11.2006C1 14.0165 2.12 16.5667 3.9295 18.4125L18.643 34.0093C19.939 35.3302 22.061 35.3302 23.358 34.0093L38.07 18.4125C39.88 16.5662 41 14.016 41 11.2006C41 5.56887 36.5245 1 31 1Z","stroke":"#04968B","strokeWidth":"2"}));
}

Heart.defaultProps = {"width":"42","height":"36","viewBox":"0 0 42 36","fill":"none"};

module.exports = Heart;

Heart.default = Heart;
